// Gap type display mappings
export const getGapTypeLabel = (gapType: string): string => {
  const labels: Record<string, string> = {
    'paa_not_answered': 'Unanswered FAQ',
    'missing_info': 'Missing Information',
    'thin_content': 'Needs More Detail',
    'schema_property': 'Schema Data Missing'
  };
  
  return labels[gapType] || gapType.replace(/_/g, ' ').replace(/\b\w/g, l => l.toUpperCase());
};

// Gap type colors
export const getGapTypeColor = (gapType: string): 'error' | 'warning' | 'info' => {
  if (gapType === 'paa_not_answered') return 'error';
  if (gapType === 'missing_info') return 'warning';
  return 'info';
};

// Priority display
export const getPriorityLabel = (priority: number): string => {
  if (priority >= 5) return 'Critical';
  if (priority >= 4) return 'High';
  if (priority >= 3) return 'Medium';
  if (priority >= 2) return 'Low';
  return 'Minor';
};

export const getPriorityColor = (priority: number): 'error' | 'warning' | 'success' | 'info' => {
  if (priority >= 5) return 'error';
  if (priority >= 4) return 'warning';
  if (priority >= 3) return 'info';
  return 'success';
};